"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Switch = _interopRequireDefault(require("@mui/material/Switch"));
var _styles = require("@mui/material/styles");
var _CLabel = _interopRequireDefault(require("./CLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StyledFormControlLabel = (0, _styles.styled)(_FormControlLabel.default, {
  shouldForwardProp: prop => prop !== '$shiftLeft'
})(_ref => {
  let {
    $shiftLeft
  } = _ref;
  return _objectSpread({}, !!$shiftLeft && {
    marginLeft: 0
  });
});

/**
 * スイッチ部品
 * @param {boolean} checked - 選択値
 * @prop {string} [label] - ラベルに表示する文字列
 * @prop {bool} [required=false] - 必須ラベルを表示する場合true
 * @prop {string} [hint] - ヒントコンテンツのid
 * @param {fuction} onChange - 変更時ハンドラ<br/>
 * シグネチャ：(checked:bool):void
 * @prop {string} [className] - FormControlLabelに指定するclassName
 * @prop {bool} [shiftLeft] - 左詰めするか
 */
const CSwitch = props => {
  const {
    label,
    required,
    hint,
    checked,
    className,
    shiftLeft
  } = props;
  const handleChange = e => {
    props.onChange(e.target.checked);
  };

  // number(0/1)やundefinedが渡されてもbooleanへ正規化
  const normalizedChecked = typeof checked === 'number' ? checked !== 0 : !!checked;
  return /*#__PURE__*/_react.default.createElement(StyledFormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_Switch.default, {
      checked: normalizedChecked,
      color: "secondary"
    }),
    label: label ? /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label,
      required,
      hint
    }) : undefined,
    labelPlacement: "start",
    onClick: event => event.stopPropagation(),
    onChange: handleChange,
    className: className,
    $shiftLeft: shiftLeft
  });
};
CSwitch.propTypes = {
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  label: _propTypes.default.string,
  required: _propTypes.default.bool,
  hint: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  shiftLeft: _propTypes.default.bool
};
var _default = exports.default = CSwitch;